import React, { useState } from "react";
import { Table } from "antd";
import { couponTypes } from "../../../../../types";
import { ColumnType } from "antd/es/table";

type DragTableProps = {
  data: typeof couponTypes.groupCoupon[];
  onDragEnd: (newData: typeof couponTypes.groupCoupon[]) => void;
  columns: ColumnType<typeof couponTypes.groupCoupon>[];
  loading: boolean;
};

const DragTable: React.FC<DragTableProps> = ({ data, onDragEnd, columns, loading }) => {
  const [draggedRow, setDraggedRow] = useState<typeof couponTypes.groupCoupon | null>(null);

  const handleDragStart = (e: React.DragEvent<HTMLTableRowElement>, record: typeof couponTypes.groupCoupon) => {
    setDraggedRow(record);
    e.dataTransfer.setData("text", JSON.stringify(record));
  };

  const handleDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent<HTMLTableRowElement>, targetRow: typeof couponTypes.groupCoupon) => {
    e.preventDefault();
    if (draggedRow) {
      const newData = [...data];
      const draggedIndex = newData.findIndex((item) => item.id === draggedRow.id);
      const targetIndex = newData.findIndex((item) => item.id === targetRow.id);

      newData[draggedIndex] = targetRow;
      newData[targetIndex] = draggedRow;

      onDragEnd(newData);
    }
  };

  const onRow = (record: typeof couponTypes.groupCoupon) => ({
    draggable: true,
    onDragStart: (e: React.DragEvent<HTMLTableRowElement>) => handleDragStart(e, record),
    onDragOver: (e: React.DragEvent<HTMLTableRowElement>) => handleDragOver(e),
    onDrop: (e: React.DragEvent<HTMLTableRowElement>) => handleDrop(e, record),
  });

  return <Table
    style={{ marginTop:10 }}
    rowKey="id"
    columns={columns}
    dataSource={data}
    loading={loading}
    onRow={onRow}
    pagination={false}
  />;
};

export default DragTable;
